import Vue from 'vue'

Vue.filter('convertTime', (value) => {
    if (!value) return ''

    const split = value.split(' ')

    const dateTemp = split[0].split('-')
    const timeTemp = split[1].split(':')

    const dateObj = new Date(dateTemp[0], dateTemp[1], dateTemp[2])

    dateObj.setHours(timeTemp[0], timeTemp[1])

    return dateObj
})
